import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const StyledNavBar = styled.div`
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
    padding: 2px 16px;
    border-width: 1px 0;
    border-style: solid;
    border-color: ${({ theme }) => theme.uiBricks.textinputDividerColor};
    background-color: ${(props) => props.theme.uiBricks.primaryAccentColor || '#0A468D'};
    color: ${({ theme }) => theme.uiBricks.modalBackgroundColor};
    height: 40px;

    @media (max-width: ${BreakPoints.PHONE}) {
        gap: 8px;
        padding: 2px 12px;
    }
`;

export const LeftSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`;

// 16x16 hug box (Figma "vertical-divider"); centering the 1x8px line via absolute
// positioning avoids the flex/border-box shrink-to-0 bug (padding-based centering on a
// border-box 16px box leaves 0px of content area, so a flex-centered line gets squeezed away).
export const Divider = styled.span`
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-radius: 2px;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1px;
        height: 8px;
        transform: translate(-50%, -50%);
        background-color: ${({ theme }) => theme.uiBricks.modalBackgroundColor};
    }
`;

export const RightSection = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;
